import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { VideoWallGrid } from './VideoWallGrid';
import Theme from '../../styles/Theme/Theme';
import { io } from 'socket.io-client';
import { websocketPort } from '../../server/websocketPort';
import { useAuthContext } from '../../contexts/AuthContext';

const ControllerContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${Theme.colors?.['neutral-0.5'] || '#F5F8FA'};
`;

const Header = styled.div`
  padding: 20px 48px;
  background: ${Theme.colors?.white || '#FFFFFF'};
  border-bottom: 3px solid ${Theme.colors?.['green-deloitte'] || '#86BC25'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const HeaderContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderLeft = styled.div``;

const LogoutButton = styled.button`
  padding: 8px 20px;
  background: transparent;
  color: ${Theme.colors?.['coolgray-9'] || '#75787B'};
  border: 1px solid ${Theme.colors?.['coolgray-5'] || '#C4C6C8'};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${Theme.colors?.['green-deloitte'] || '#86BC25'};
    color: #fff;
    border-color: ${Theme.colors?.['green-deloitte'] || '#86BC25'};
  }
`;

const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: ${Theme.colors?.['coolgray-12'] || '#222222'};
  letter-spacing: -0.5px;
`;

const GridWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

export const VideoWallController = () => {
  const { logout } = useAuthContext();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const socketInstance = io(websocketPort, {
      transports: ['websocket'],
      reconnection: true
    });

    socketInstance.on('connect', () => {
      console.log('VideoWallController: Connected to WebSocket:', websocketPort);
    });

    socketInstance.on('disconnect', () => {
      console.log('VideoWallController: Disconnected from WebSocket');
    });

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
  }, []);

  const handleZoneUpdate = ({ zones, canvasWidth, mapLayerConfig }) => {
    if (socket) {
      const updateData = { zones, mapLayerConfig };
      console.log('VideoWallController: Emitting zone update:', updateData);
      console.log('   - Zona A:', zones?.zoneA?.layout?.length || 0, 'widgets');
      console.log('   - Zona B:', zones?.zoneB?.layout?.length || 0, 'widgets');
      console.log('   - Zona C:', zones?.zoneC?.layout?.length || 0, 'widgets');
      console.log('   - Zona X:', zones?.zoneX?.layout?.length || 0, 'widgets');
      console.log('   - Zona Z:', zones?.zoneZ?.layout?.length || 0, 'widgets');
      socket.emit('videowall_zone_update', updateData);
      console.log('Emitted successfully');
    } else {
      console.warn('VideoWallController: Socket not connected, cannot emit update');
    }
  };
  return (
    <ControllerContainer>
      <Header>
        <HeaderContent>
          <HeaderLeft>
            <Title>Video Wall Controller</Title>
          </HeaderLeft>
          <LogoutButton onClick={logout}>Logout</LogoutButton>
        </HeaderContent>
      </Header>
      <GridWrapper>
        <VideoWallGrid onZoneUpdate={handleZoneUpdate} />
      </GridWrapper>
    </ControllerContainer>
  );
};

export default VideoWallController;
